export default __webpack_public_path__ + "static/media/close.ec2ce0b9.svg";